import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'acris-blog-title',
    label: 'acris-blog.blocks.blogTitle.label',
    category: 'acris-blog',
    component: 'sw-cms-block-acris-blog-title',
    previewComponent: 'sw-cms-preview-acris-blog-title',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: null,
        marginRight: null,
        sizingMode: 'boxed'
    },
    slots: {
        column: {
            type: 'acris-blog-title'
        },
    }
});
